import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_INSPECTIONS,
  GET_INSPECTION_DETAILS,
  CREATE_INSPECTION,
  UPDATE_INSPECTION,
  CHECK_INSPECTION_NUMBER,
  GET_INSPECTIONS_BOOKING,
  GET_INSPECTION_BOOKING_DETAILS,
  CREATE_INSPECTION_BOOKING,
  UPDATE_INSPECTION_BOOKING,
  DELETE_INSPECTION,
  PUT_WHATSAPP_SHARE,
  PUT_WHATSAPP_SHARE_PDF,
} from "./actionTypes"
import {
  checkInspectionNumberFail,
  checkInspectionNumberSuccess,
  createInspectionBookingFail,
  createInspectionBookingSuccess,
  createInspectionFail,
  createInspectionSuccess,
  deleteInspectionFail,
  deleteInspectionSuccess,
  getInspectionBookingDetailsFail,
  getInspectionBookingDetailsSuccess,
  getInspectionDetailsFail,
  getInspectionDetailsSuccess,
  getInspectionsBookingFail,
  getInspectionsBookingSuccess,
  getInspectionsFail,
  getInspectionsSuccess,
  putWhatsappShareFail,
  putWhatsappSharePdfFail,
  putWhatsappSharePdfSuccess,
  putWhatsappShareSuccess,
  updateInspectionBookingFail,
  updateInspectionBookingSuccess,
  updateInspectionFail,
  updateInspectionSuccess,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

function getInspectionAPi({ page, limit, searchText, StaffId, sortByDate }) {
  return get(
    `/inspection-document/admin/all/?page=${page ? page : 1}&limit=${
      limit ? limit : 10
    }&search=${searchText}&from=${sortByDate?.from || ""}&to=${
      sortByDate?.to || ""
    }&inspected_by=${StaffId ? StaffId : ""}`
  )
}

const getInspectionDetailsAPi = inspectionId => {
  return get(`/inspection-document/admin/${inspectionId}`)
}

const createInspectionApi = ({ inspection }) => {
  return post("/inspection-document/admin/new", inspection)
}

const updateInspectionApi = ({ inspection, inspectionId }) => {
  return ApiPut(`/inspection-document/admin/${inspectionId}`, inspection)
}

const deleteInspectionApi = inspectionId => {

  return del(`/inspection-document/admin/${inspectionId}`)
}

function getInspectionBookingAPi({
  page,
  sort,
  limit,
  searchText,
  sortByDate,
}) {
  return get(
    `/inspection-booking/admin/all/?page=${page ? page : 1}&sort=${
      sort || ""
    }&limit=${limit ? limit : 10}&search=${searchText}&from=${
      sortByDate?.from || ""
    }&to=${sortByDate?.to || ""}`
  )
}

const getInspectionBookingDetailsAPi = inspectionBookingId => {
  return get(`/inspection-booking/${inspectionBookingId}`)
}

const createInspectionBookingApi = ({ inspectionBooking }) => {
  return post("/inspection-booking/admin/new", inspectionBooking)
}

const updateInspectionBookingApi = ({
  inspectionBooking,
  inspectionBookingId,
}) => {

  return ApiPut(
    `/inspection-booking/admin/${inspectionBookingId}`,
    inspectionBooking
  )
}
const putWhatsappShareAPi = inspectionBookingId => {
  return post(`/whatsapp-api/admin/inspection-booking/${inspectionBookingId}`)
}
const putWhatsappSharePdfAPi = inspectionBookingId => {
  return post(
    `/whatsapp-api/admin/inspection-certificate/${inspectionBookingId}`
  )
}
function* fetchInspections({ payload }) {
  try {
    const response = yield call(getInspectionAPi, payload)
    yield put(getInspectionsSuccess(response))
  } catch (error) {
    yield put(getInspectionsFail(error))
  }
}

function* fetchInspectionDetails({ payload: vehicleId }) {
  try {
    const response = yield call(getInspectionDetailsAPi, vehicleId)
    yield put(getInspectionDetailsSuccess(response))
  } catch (error) {
    yield put(getInspectionDetailsFail(error))
  }
}

function* onCreateInspection({ payload }) {
  try {
    const response = yield call(createInspectionApi, payload)
    if (response?.message) {
      Notification({
        type: "error",
        message: response?.message,
        title: "",
      })
    } else if (response?._id) {
      yield put(createInspectionSuccess(response))
      payload?.history?.push("/inspection/all")
      doneNotification("Inspection Created Successfully!")
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createInspectionFail(error))
  }
}

function* onUpdateInspection({ payload }) {

  try {
    const response = yield call(updateInspectionApi, payload)
    if (response) {
      try {
        const detailResponse = yield call(
          getInspectionDetailsAPi,
          payload.inspection?.inspection_data?.inspection_number
        )

        if (payload.setSuccess) {
          payload.setSuccess(true)
        }
        Notification({
          type: "success",
          message: "Inspection Updated Successfully!",
          title: "",
        })
        yield put(getInspectionDetailsSuccess(detailResponse))
        yield put(updateInspectionSuccess(response))
      } catch (error) {
        yield put(getInspectionDetailsFail(error))
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateInspectionFail(error.response.data))
  }
}

function* onDeleteInspection({ payload: InspectionId }) {
  try {
    const response = yield call(deleteInspectionApi, InspectionId)
    yield put(deleteInspectionSuccess(response))
    Notification({
      type: "success",
      message: "Inspection Deleted Successfully!",
      title: "",
    })
  } catch (error) {

    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteInspectionFail(error?.response?.data))
  }
}
// booking

function* fetchInspectionsBooking({ payload }) {
  try {
    const response = yield call(getInspectionBookingAPi, payload)
    yield put(getInspectionsBookingSuccess(response))
  } catch (error) {
    yield put(getInspectionsBookingFail(error))
  }
}

function* fetchInspectionBookingDetails({ payload: vehicleId }) {
  try {
    const response = yield call(getInspectionBookingDetailsAPi, vehicleId)
    yield put(getInspectionBookingDetailsSuccess(response))
  } catch (error) {
    yield put(getInspectionBookingDetailsFail(error))
  }
}

function* onCreateInspectionBooking({ payload }) {

  try {
    const response = yield call(createInspectionBookingApi, payload)
    if (response?.message) {
      Notification({
        type: "error",
        message: response?.message,
        title: "",
      })
    } else if (response) {
      try {
        const viewResponse = yield call(putWhatsappShareAPi, response?._id)
        yield put(putWhatsappShareSuccess(viewResponse))
      } catch (error) {
        yield put(putWhatsappShareFail(error))
      }
      yield put(createInspectionBookingSuccess(response))
      payload?.history?.push("/inspection-booking/all")
      doneNotification("Inspection Booking Created Successfully!")
    }
  } catch (error) {

    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createInspectionBookingFail(error))
  }
}

function* onUpdateInspectionBooking({ payload }) {
  try {
    const response = yield call(updateInspectionBookingApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Inspection Booking Updated Successfully!",
        title: "",
      })

      yield put(updateInspectionBookingSuccess(response))
      if (payload.history) {
        payload.history.goBack()
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateInspectionBookingFail(error.response.data))
  }
}

function* onCheckInspectionNumber({ payload }) {
  try {
    const response = yield call(checkInspectionNumberApi, payload)
    yield put(checkInspectionNumberSuccess(response))
  } catch (error) {
    yield put(checkInspectionNumberFail(error))
  }
}

function* putWhatsappShare({ payload }) {
  const { inspectionBookingId, setLoading } = payload
  if (setLoading) setLoading(true) // ✅ set loading true before API call

  try {
    const response = yield call(putWhatsappShareAPi, inspectionBookingId)

    if (response) {
      Notification({
        type: "success",
        message: "WhatsApp message sent successfully to customer.",
        title: "",
      })

      yield put(putWhatsappShareSuccess(response))

      try {
        const viewResponse = yield call(
          getInspectionBookingDetailsAPi,
          inspectionBookingId
        )
        yield put(getInspectionBookingDetailsSuccess(viewResponse))
      } catch (error) {
        yield put(getInspectionBookingDetailsFail(error))
      }
    }

    if (setLoading) setLoading(false) // ✅ set loading false after success
  } catch (error) {
    yield put(putWhatsappShareFail(error))
    if (setLoading) setLoading(false) // ✅ set loading false on error
  }
}
function* putWhatsappSharePdf({ payload }) {
  const { inspectionBookingId, inspectionDetails, setLoading } = payload
  if (setLoading) setLoading(true) // ✅ set loading true before API call

  try {
    const response = yield call(putWhatsappSharePdfAPi, inspectionBookingId)

    if (response) {
      Notification({
        type: "success",
        message: "WhatsApp message sent successfully to customer.",
        title: "",
      })

      yield put(putWhatsappSharePdfSuccess(response))

      try {
        const viewResponse = yield call(
          getInspectionDetailsAPi,
          inspectionDetails
        )
        yield put(getInspectionDetailsSuccess(viewResponse))
      } catch (error) {
        yield put(getInspectionDetailsFail(error))
      }
    }

    if (setLoading) setLoading(false) // ✅ set loading false after success
  } catch (error) {
    yield put(putWhatsappSharePdfFail(error))
    if (setLoading) setLoading(false) // ✅ set loading false on error
  }
}

function* inspectionSaga() {
  yield takeEvery(GET_INSPECTIONS, fetchInspections)
  yield takeEvery(GET_INSPECTION_DETAILS, fetchInspectionDetails)
  yield takeEvery(CREATE_INSPECTION, onCreateInspection)
  yield takeEvery(UPDATE_INSPECTION, onUpdateInspection)
  yield takeEvery(CHECK_INSPECTION_NUMBER, onCheckInspectionNumber)
  yield takeEvery(DELETE_INSPECTION, onDeleteInspection)

  // booking
  yield takeEvery(GET_INSPECTIONS_BOOKING, fetchInspectionsBooking)
  yield takeEvery(GET_INSPECTION_BOOKING_DETAILS, fetchInspectionBookingDetails)
  yield takeEvery(CREATE_INSPECTION_BOOKING, onCreateInspectionBooking)
  yield takeEvery(UPDATE_INSPECTION_BOOKING, onUpdateInspectionBooking)
  yield takeEvery(PUT_WHATSAPP_SHARE, putWhatsappShare)
  yield takeEvery(PUT_WHATSAPP_SHARE_PDF, putWhatsappSharePdf)
}

export default inspectionSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
